
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import Home from './home/index.page'
import React, {ReactNode} from 'react'
import MainLayout from '@/layouts/MainLayout'

const HomePage = () => {
  return (
    <div className="App">
      <Home />
    </div>
  )
}

const getLayout = (page: ReactNode) => {
  return <MainLayout>{page}</MainLayout>
}

HomePage.getLayout = getLayout

export default HomePage
